<template>
  <div class="depSetting">
    <!-- 修改项目部弹窗-->
    <el-dialog
      title="设置部门"
      :visible.sync="isDialogShow"
      :close-on-click-modal="false"
      width="600px"
    >
      <el-form
        :model="deptForm"
        label-width="100px"
        ref="deptForm"
        :rules="rules"
      >
        <el-row>
          <el-col :span="3">
            <el-form-item label="编号">
              <!-- <el-input v-model="pwdForm.oldPassword" autocomplete="off" type="password"></el-input> -->
            </el-form-item>
          </el-col>
          <el-col :span="19">
            <el-form-item label="">
              <div>对应项目部</div>
              <!-- <el-input v-model="pwdForm.oldPassword" autocomplete="off" type="password"></el-input> -->
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-for="deptItem in this.deptForm" :key="deptItem.viewValue">
          <el-col :span="3">
            <el-form-item :label="deptItem.viewIndex">
              <!-- <el-input v-model="pwdForm.newPassword" autocomplete="off" type="password"></el-input> -->
            </el-form-item>
          </el-col>
          <el-col :span="19">
            <el-form-item label="" prop="deptId" label-width="80px">
              <el-select v-model="deptItem.deptId" placeholder="请选择">
                <el-option
                  v-for="item in deptIdList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
       <el-row>
          <el-col :span="3">
            <el-form-item label="8">
              <!-- <el-input v-model="pwdForm.newPassword" autocomplete="off" type="password"></el-input> -->
            </el-form-item>
          </el-col>
          <el-col :span="19">
            <el-form-item label=""  label-width="80px">
              <div>其它</div>
             
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" @click="isDialogShow = false">取 消</el-button>
        <el-button type="primary" @click="saveDeptClick()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getsubDeptService, //获取项目部二级项目级联列表
  getDeptListService, //根据组织获取项目部一级数据下拉列表
} from "@/services/sysSettingService";
import {
  queryDeptSetting,
  createOrUpdateDeptSetting,
} from "../../services/dataCenterAService";
export default {
  name: "depSetting",
  data() {
    return {
      isDialogShow: false,
      deptIdList: [],
      deptForm: [ {
        'analysisType':'',
		"deptId": 0,
		"deptName": "",
		"viewIndex": 1
	}, {
		"deptId": 0,
		"deptName": "",
		"viewIndex": 2
	}, {
		"deptId": 0,
		"deptName": "",
		"viewIndex": 3
	}, {
		"deptId": 0,
		"deptName": "",
		"viewIndex": 4
	}, {
		"deptId": 0,
		"deptName": "",
		"viewIndex": 5
	}, {
		"deptId": 0,
		"deptName": "",
		"viewIndex": 6
	}, {
		"deptId": 0,
		"deptName": "",
		"viewIndex": 7
	}],
      userCode: "",
      rules: {
        oldPassword: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            min: 6,
            max: 20,
            message: "长度在 6 到 20 个字符",
            trigger: "blur",
          },
          {
            pattern: /^[0-9a-zA-Z]+$/,
            message: "只能输入数字或英文",
            trigger: "blur",
          },
        ],
        newPassword: [
          { required: true, message: "请确认密码", trigger: "blur" },
          {
            min: 6,
            max: 20,
            message: "长度在 6 到 20 个字符",
            trigger: "blur",
          },
          {
            pattern: /^[0-9a-zA-Z]+$/,
            message: "只能输入数字或英文",
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    //获取项目部
    // this.getDept();
  },
  methods: {
    showDeptDialog(analysisType) {
      this.getDept(analysisType);
      this.deptForm.forEach(item=>{
        item.analysisType=analysisType;
      })
      this.userCode = sessionStorage.getItem("currentUserId");
      this.isDialogShow = true;
    },
    //获取项目部列表下拉数据
    getDept(analysisType) {
      let param = {};
      param.deptId = 101;
      getsubDeptService(param).then((res) => {
        if (res.code == 10000000) {
          this.deptIdList = res.data;
          this.getDeptData(analysisType);
        }
      });
    },
    //获取已设置的项目部
    getDeptData(analysisType) {     
      queryDeptSetting({analysisType:analysisType}).then((res) => {
        if (res.code == 10000000) {         
            this.deptForm = res.data;        
        }
      });
    },

    /* 修改项目部 保存按钮回调 */
    saveDeptClick() {
      this.$refs.deptForm.validate((res) => {
        if (res) {
          this.deptForm.forEach(ele => {
            let i=this.deptIdList.findIndex(item=>item.id==ele.deptId)
            ele.deptName=this.deptIdList[i].name;
            ele.viewIndex=ele.viewIndex;
            ele.deptId=ele.deptId
            return ele
            
          });
          console.log(this.deptForm)
           //保存设置的项目部
        createOrUpdateDeptSetting(this.deptForm)
          .then((res) => {
            if (res.code == 10000000) {
              this.$message.success('保存成功')
              this.$emit('getDept');
             this.isDialogShow = false;
              
            } else if (res.code >= 20000000) {
             
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
             
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          })
          .catch((error) => {
            this.$alert(error, "提示", {
              confirmButtonText: "确定",
            });
          });
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.depSetting {
  /deep/.el-dialog {
    /deep/.el-icon-view:before {
      display: none;
    }
  }
  /deep/.el-select {
    width: 100%;
  }
}
</style>
